import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const CouponMessage = ({ data = {}, showPersonalizado = true, inCart = false,linesMsgMaior=null}) => {
    const replaceCharacters = (message_text) => {
        if(message_text.includes("|")){
            message_text = message_text.replace('|', '<strong>');
            message_text = message_text.replace('|', '</strong>');
        }
        return message_text;
    }
    const formatMessageAlt = (position, messageArray = [], withClass = false) => {
        let concatFormat = [];
        if(!messageArray) return "";
        //top
        //<p className="title">Llévate tres galletas<br/>y solo paga <strong>dos</strong></p>
        //bottom
        //<p className="note box">Ahorra hasta S/ 2.50</p>
        //<p className="title">a toda tu compra.</p><p className="note">Máximo s/30 de dscto.</p>
        //<p class="title">a toda tu compra.</p><p class="note">(Si pagas con tarjeta cencosud s/5.00 adicionales)</p>
        let itemsFound = 0;
        let hasMultipleLine = false;
        let countMultipleLine = 0;
        messageArray.map( message => {
            if(message.position === position && message.small) hasMultipleLine = true;
        });
        messageArray.map( message => {
            if(message.position === position ){
                let classLine = '';
                let classMini = 'note';
                if(message.text.toLowerCase().includes('ahorra')){
                    classMini = 'note box';
                }
                if(messageArray.length > 1){
                    classLine = itemsFound===0 ? 'title':'note';
                }else{
                    classLine = classMini;
                }
                concatFormat.push(`
                    ${message.small?(((hasMultipleLine&&countMultipleLine<1)||!hasMultipleLine)?'<small class="'+classMini+'">':''):(withClass?'<p class="'+classLine+'">':'')}
                        ${message.bold?'<strong>':''}
                            ${replaceCharacters(message.text)}
                        ${message.bold?'</strong>':''}
                    ${message.small?(!hasMultipleLine?'</small>':''):(withClass?'</p>':'')}
                `);
                itemsFound++;
                if(hasMultipleLine && message.small) countMultipleLine++;
            }
        });
        if(hasMultipleLine) concatFormat.push('</small>');

        return concatFormat.join(" ");
    }
    const formatMessagePrice = (strPrice1 = '', strPrice2 = '') => {
        let concatFormat = '';
        //<span className="number">3x2</span>
        //<span className="number">20</span><sup>%</sup><sub>dscto.</sub>
        //<sub>S/</sub><span className="number">10</span><sub>dscto.</sub>
        //<sub>S/</sub><span className="number">10</span><sup>.00</sup>
        strPrice2 = strPrice2.toLowerCase();
        if(strPrice2.includes('dscto')){
            strPrice2 = strPrice2.replace('dscto.', '').replace('dscto', '').trim();
            concatFormat = `<sub>dscto.</sub>`;
        }
        if(strPrice2.includes('%')){
            strPrice2 = strPrice2.replace('%', '').trim();
            concatFormat = `<span class="number">${strPrice2}</span><sup>%</sup>${concatFormat}`;
        }else if(strPrice2.includes('s/') || strPrice1.includes('s/')){
            let strSup = '';
            strPrice2 = strPrice2.replace('s/.', '').replace('s/', '').trim();
            if(strPrice2.indexOf('.')!==-1){
                const strPrice2_parts = strPrice2.split('.');
                strPrice2 = strPrice2_parts[0];
                strSup = `<sup>.${strPrice2_parts[1]}</sup>`;
            }
            concatFormat = `<sub>S/</sub><span class="number">${strPrice2}</span>${strSup!==''?strSup:''}${concatFormat}`;
        }else if(strPrice2 !== ''){
            concatFormat = `<span class="number">${strPrice2}</span>`;
        }

        return concatFormat !== '' ? concatFormat : strPrice1;
    }
    const precioAverage =(value)=>{
        return value?.toFixed(2);

    }

    function MaterialList() {
        if(linesMsgMaior!=0){
    
       const numbers=Array.from(Array(linesMsgMaior).keys());
       
     
       const listItems=numbers.map((element,index)=>
       <br key={index}/>
       );
       return <div>{listItems}</div>;
       }
    }


    return (
        <>
            {data.personalizado && showPersonalizado && <label className={"btn no-hover label-floating"+(inCart?" white":"")}>Para ti</label>}
            {data.textDiscount && data.textDiscount.includes("%")
                ?
                <>
                <p data-type="2" className="empty"></p>
                <p className="title" dangerouslySetInnerHTML={{__html: formatMessageAlt('top', data.messages?data.messages.message4:null)}}></p>
                <p className="price" dangerouslySetInnerHTML={{__html: formatMessagePrice(data.discount, data.textDiscount)}}></p>
                <div dangerouslySetInnerHTML={{__html: formatMessageAlt('bottom', data.messages?data.messages.message4:null, true)}}></div>
                </>
                :
                (data.textDiscount && data.textDiscount.includes("dscto")
                    ?
                    <>
                    <p data-type="4" className="empty"></p>
                    <p className="title" dangerouslySetInnerHTML={{__html: formatMessageAlt('top', data.messages?data.messages.message4:null)}}></p>
                    <p className="price" dangerouslySetInnerHTML={{__html: formatMessagePrice(data.discount, data.textDiscount)}}></p>
                    <div dangerouslySetInnerHTML={{__html: formatMessageAlt('bottom', data.messages?data.messages.message4:null, true)}}></div>
                    </>
                    :
                    (data.textDiscount && data.textDiscount.includes("S/")
                        ?
                        <>
                        <p data-type="3" className="empty"></p>
                        <p className="title" dangerouslySetInnerHTML={{__html: formatMessageAlt('top', data.messages?data.messages.message4:null)}}></p>
                        <p className="price" dangerouslySetInnerHTML={{__html: formatMessagePrice(data.discount, data.textDiscount)}}></p>
                        <div dangerouslySetInnerHTML={{__html: formatMessageAlt('bottom', data.messages?data.messages.message4:null, true)}}></div>
                        </>
                        :
                        <>
                        <p data-type="1" className="empty"></p>
                        <p className="title" dangerouslySetInnerHTML={{__html: formatMessageAlt('top', data.messages?data.messages.message4:null)}}></p>
                        <p className="price" dangerouslySetInnerHTML={{__html: formatMessagePrice(data.discount, data.textDiscount)}}></p>
                        <div dangerouslySetInnerHTML={{__html: formatMessageAlt('bottom', data.messages?data.messages.message4:null)}}></div>
                        </>
                    )
                )
            }
           <>
            {MaterialList()}
           </>
           {/* show Precio Regular */}
           
            {data.nivelMaterial &&  data.textDiscount.includes("S/") &&
            <>
             <br></br>
            <div className='regular-price'>Precio Regular</div>
            <p className='regular-price-value'>S/. {precioAverage(data.averagePrecioRegular)}</p>
            
            </>
            }
            
        </>
    );
}

CouponMessage.propTypes = {
    data: PropTypes.object,
    showPersonalizado: PropTypes.bool,
    inCart: PropTypes.bool,
    linesMsgMaior:PropTypes.number
};

export default CouponMessage;